import { addHook } from '@viveaesthetics/elemy-shared-core/lib/utils/mockHooks'
import { genericErrorHandler, getHostName } from '@viveaesthetics/shared-domain'
import { useActiveSaasWorkspaceId } from '@viveaesthetics/shared'

import { publicClient } from '@/graphql/client'
import {
  GetDomainByAppNameQuery,
  useGetDomainByAppNameQuery
} from '@/graphql/generated/schema'
import {
  findMatchingDomainsBySubdomain,
  getRootDomainFromHostname
} from '@/utils/uri'

const DEFAULT_HOSTNAME = 'dev.jointhesupportnetwork.com'
const CURRENT_HOSTNAME =
  process.env.NODE_ENV === 'development' ? DEFAULT_HOSTNAME : getHostName()
const CURRENT_ROOT_DOMAIN = getRootDomainFromHostname(CURRENT_HOSTNAME)

const transform = (data: GetDomainByAppNameQuery) => {
  if (!data) return ''
  const domainList = data.applicationConfig.map(appConfig => appConfig.domain)

  const domain = findMatchingDomainsBySubdomain(CURRENT_HOSTNAME, domainList)

  return domain
}

interface UseGetDomainByAppNameProps {
  applicationName: string
}

export const useGetDomainByAppName = addHook({
  useGetDomainByAppName: ({ applicationName }: UseGetDomainByAppNameProps) => {
    const { activeSaasWorkspaceId } = useActiveSaasWorkspaceId()
    const {
      data: domain,
      isLoading,
      fetchStatus
    } = useGetDomainByAppNameQuery(
      publicClient,
      {
        applicationName,
        rootDomain: `%${CURRENT_ROOT_DOMAIN}`,
        saasWorkspaceId: activeSaasWorkspaceId
      },
      {
        onError: genericErrorHandler,
        select: transform
      }
    )

    return {
      domain,
      isLoading: isLoading && fetchStatus !== 'idle'
    }
  }
})
